import React from 'react';
import { personal, photos } from '../data';
import './Footer.css';

const entries = [
  { label: 'Email',    value: personal.email,       href: `mailto:${personal.email}` },
  { label: 'LinkedIn', value: 'in/noah-pangilinan', href: personal.linkedin, external: true },
  { label: 'GitHub',   value: '@noahpangilinan',    href: personal.github, external: true },
  { label: 'Résumé',   value: 'PDF, one page',      href: personal.resumeUrl, external: true },
];

export default function Footer() {
  return (
    <footer id="contact" className="section register" data-scene="helens">
      <div className="panel">
        <div>
          <h2 className="register__title">Trail register</h2>
          <p className="register__sub">
            I graduate in December 2026 and I’m looking for full-time software engineering roles.
            Email is the best way to reach me.
          </p>
        </div>

        <ul className="register__lines">
          {entries.map((e) => (
            <li key={e.label}>
              <a href={e.href} {...(e.external ? { target: '_blank', rel: 'noreferrer' } : {})}>
                <span className="register__label">{e.label}</span>
                <span className="register__value">{e.value}</span>
                <span className="register__arrow" aria-hidden="true">→</span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="register__base">
        <p>© {new Date().getFullYear()} {personal.name} {personal.lastName} · Built with React</p>
        <p className="register__credits">
          Photos are mine except these, from Wikimedia Commons (resized):{' '}
          {Object.values(photos).filter((ph) => !ph.mine).map((ph, i, all) => (
            <span key={ph.source}>
              <a href={ph.source} target="_blank" rel="noreferrer">{ph.place}</a> by {ph.author} (
              {ph.licenseUrl
                ? <a href={ph.licenseUrl} target="_blank" rel="noreferrer">{ph.license}</a>
                : ph.license}
              ){i < all.length - 1 ? '; ' : '.'}
            </span>
          ))}
        </p>
      </div>
    </footer>
  );
}
